// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CcStdIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from cc-std.svg
 */
export default function CcStdIcon(props: CcStdIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CcStdIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M13.7 2.343Q11.342 0 7.985 0 4.657 0 2.371 2.329A8 8 0 0 0 .607 4.95 7.9 7.9 0 0 0 0 8a7.85 7.85 0 0 0 2.35 5.636 8.05 8.05 0 0 0 2.6 1.757A7.8 7.8 0 0 0 7.986 16a8 8 0 0 0 3.071-.614q1.486-.615 2.657-1.772a7.35 7.35 0 0 0 1.707-2.536A8.2 8.2 0 0 0 16 8a8.15 8.15 0 0 0-.586-3.078A7.7 7.7 0 0 0 13.7 2.343M3.4 3.357q1.872-1.914 4.614-1.914 2.714 0 4.644 1.929a6.4 6.4 0 0 1 1.413 2.114q.486 1.185.486 2.515 0 2.757-1.871 4.586a6.9 6.9 0 0 1-2.178 1.443q-1.209.5-2.494.5a6.4 6.4 0 0 1-2.485-.493 6.6 6.6 0 0 1-2.13-1.43 6.6 6.6 0 0 1-1.45-2.128A6.3 6.3 0 0 1 1.444 8q0-1.299.507-2.493a6.9 6.9 0 0 1 1.45-2.15m4.514 3.315-1.072.557q-.171-.357-.42-.5a.95.95 0 0 0-.465-.143q-1.072 0-1.072 1.415 0 .642.271 1.028.272.386.8.386.7 0 .987-.686l.985.5a2.35 2.35 0 0 1-2.1 1.257q-1.07 0-1.729-.657-.657-.657-.657-1.828 0-1.143.665-1.814.664-.672 1.678-.672 1.486 0 2.13 1.157m3.557.557 1.057-.557q-.628-1.157-2.114-1.157-1.015 0-1.678.672Q8.07 6.857 8.07 8q0 1.17.65 1.828t1.736.657q.657 0 1.214-.335.557-.336.885-.922l-1-.5q-.285.686-.985.686-.53 0-.8-.386Q9.5 8.643 9.499 8q0-1.415 1.072-1.415.228 0 .479.143.25.143.421.5"
        />
      </g>
    </svg>
  );
}
